import React, { Fragment } from 'react';
import { highlightCoefChanges } from '~/web-frontend-components/line/outcomes/additional/tables/Td';
export const InlineOutcomes = (props) => {
    if (!props.additionalOdds || props.additionalOdds.length === 0) {
        return null;
    }
    return <div className="g-a-other">
      <b>{props.toLocale('ADDITIONAL_BETS')}</b>
      {props.additionalOdds
            .filter((cell) => !!cell.bet)
            .map((cell, i) => cell.bet ?
            <HightlightCoef key={`${props.getCoef(cell.bet).odd}_${i}`} highlightChanges={props.highlightChanges} isCoefChoosen={props.isCoefChoosen} coef={props.getCoef(cell.bet)} onClick={props.onCoefChoose} disabled={!!props.disabled} cell={cell} style={{}}/> : null)}
   </div>;
};
const InlineCoef = (props) => <Fragment>
   {props.cell.txt} - &nbsp;
   <a className={`g-b ${props.isChoosen ? 'g-b-s' : ''}`} onClick={() => { props.cfID && props.onClick(props.cfID); }}>{props.cf}</a>
   ;{` `}
</Fragment>;
const HightlightCoef = React.memo(highlightCoefChanges(InlineCoef));



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/matches/list/sport/championship/additional/InlineOutcomes.jsx